/**
 * @namespace components
 */

import React from 'react';
// import classNames from 'classnames';
import PropTypes from 'prop-types';
import { miniGazelle } from '../../../helpers';
import ExpandableList from '../../shared/ExpandableList/ExpandableList';
import './SwtPopularTopics.scss';
import PopularTopicsIcon from '../../shared/SonyIcon/icons/PopularTopicsIcon';

/**
 * @class SwtPopularTopics
 *
 * SwtPopularTopics module - ???
 *
 * @memberof components
 * @author ??? <???.???@sony.com>
 *
 * @property {object} data - Primary object to insert data props into component
 * @property {string} data.logicalName - Logical name of the module, used as the HTML node ID
 *
 * @example
 * return {
 *   <SwtPopularTopics data={data} />
 * }
 */
export default function SwtPopularTopics({ data: { popularTopics }, logicalName }) {
    /* if no data do not render block */
    if (popularTopics.length === 0) {
        return null;
    }

    return (
        <div className="swt-popular-topics" data-testid={logicalName} id={logicalName}>
            <ExpandableList
                items={popularTopics}
                listSize={popularTopics.length}
                title={miniGazelle.label('popularTopics')}
                icon={<PopularTopicsIcon className="icon-5x" />}
            />
        </div>
    );
}
